import React, { Ref } from 'react';
import classnames from 'classnames';
import { Label, LabelProps, LabelTypes } from '@eika/label';

import { CheckboxLabel } from './CheckboxLabel';

export interface CheckboxPanelProps {
    label: string;
    options: ({
        label: string;
        checked: boolean;
        onValueChange: (checked: boolean, value?: string) => void;
        description?: string;
        ref?: Ref<HTMLInputElement>;
        value: string;
        labels?: LabelProps[];
    } & Omit<React.PropsWithoutRef<JSX.IntrinsicElements['input']>, 'onChange' | 'checked' | 'value'>)[];
    className?: string;
    sublabel?: string;
    infoButton?: React.ReactNode;
    externalLinkLabel?: React.ReactNode;
}

const CheckboxPanels = ({
    label,
    options,
    className,
    sublabel,
    infoButton,
    externalLinkLabel,
}: CheckboxPanelProps): JSX.Element => (
    <fieldset className={classnames('sgw-checkbox-panels', className)}>
        <CheckboxLabel
            label={label}
            sublabel={sublabel}
            infoButton={infoButton}
            externalLinkLabel={externalLinkLabel}
        />
        {options.map(({ checked, label, value, onValueChange, id, ref, description, labels, key, ...rest }) => (
            <label
                className={classnames('sgw-checkbox-panel-option', {
                    'sgw-checkbox-panel-option__checked': checked,
                })}
                key={key ?? id ?? label}
            >
                {labels && (
                    <span className="sgw-checkbox-panel-option__label-wrapper">
                        {labels.map((l) => (
                            <Label {...l} type={l.type ?? LabelTypes.INFO} key={l.key ?? l.id} />
                        ))}
                    </span>
                )}
                <span className="sgw-checkbox">
                    <input
                        type="checkbox"
                        value={value}
                        checked={checked}
                        onChange={(event) => {
                            onValueChange(event.target.checked, value);
                        }}
                        id={id}
                        ref={ref}
                        {...rest}
                    />
                </span>
                <span className="sgw-checkbox__label">{label}</span>
                {description && <span className="sgw-checkbox-panel-option-description">{description}</span>}
            </label>
        ))}
    </fieldset>
);

export default CheckboxPanels;
